import { FaInfoCircle } from 'react-icons/fa';

const Home = () => {
  return (
    <section style={styles.section}>
      <h2 style={styles.title}>About Us</h2>
     <p style={styles.description}>
  <span style={styles.highlight}>Rodxexforden</span> is a forward-thinking IT company that provides modern digital solutions for businesses of all sizes. We help organizations leverage advanced technologies to reach their objectives with greater efficiency and performance.
</p>
<p style={styles.description}>
  Through years of hands-on experience, we have built a reputation as a dependable partner recognized for quality, consistency, and a client-focused approach. Our team collaborates closely with every client to deliver customized solutions that address real challenges and support long-term growth.
</p>
<p style={styles.description}>
  At <span style={styles.highlight}>Rodxexforden</span>, we constantly evolve our strategies and adopt the latest technologies to provide secure, reliable, and future-oriented IT solutions. Innovation, transparency, and dedication to excellence remain at the heart of everything we do.
</p>
<p style={styles.description}>
  Whether you are a startup creating a strong digital foundation or an established company seeking to streamline operations, we are ready to guide and support you at every step of the journey.
</p>

    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '60px 20px',
    textAlign: 'center',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  description: {
    fontSize: '1.2rem',
    maxWidth: '800px',
    margin: '0 auto 20px',
    lineHeight: '1.6',
  },
  highlight: {
    color: ' #f5ab2d',
    fontWeight: 'bold',
  },
};

export default Home;
